import React, { useState, useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { FaCalendar, FaClock } from 'react-icons/fa';
import './contact-sales.css';
import { ClientPreLoginService } from '../../../services/clientPreLoginService';
import Success from '../../../assets/images/im_Success.png';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import moment from 'moment/moment';

const ContactSales = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const datePickerRef = useRef(null);
  const [dateTime, setDateTime] = useState('');
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    company: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (datePickerRef.current) {
      if (datePickerRef.current._flatpickr) {
        datePickerRef.current._flatpickr.destroy();
      }

      const fp = flatpickr(datePickerRef.current, {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
        noCalendar: false,
        disableMobile: true,
        altInput: false,
        allowInput: true,
        defaultDate: "",
        onReady: function (selectedDates, dateStr, instance) {
          setTimeout(() => {
            instance.input.placeholder = "";
            instance.input.removeAttribute("placeholder");
          }, 10);
        },
        onChange: (selectedDates, dateStr) => {
          setDateTime(dateStr);
          setErrors((prevErrors) => ({ ...prevErrors, dateTime: "" }));
        },
        onClose: () => {
          datePickerRef.current.blur();
        },
      });

      return () => {
        fp.destroy();
      };
    }
  }, []);


  useEffect(() => {
    if (datePickerRef.current) {
      setTimeout(() => {
        datePickerRef.current.value = "";
        datePickerRef.current.placeholder = "";
        datePickerRef.current.removeAttribute("placeholder");
      }, 100);
    }
  }, []);

  const namePattern = /^[A-Za-z\s]+$/;
  const companyPattern = /^[A-Za-z0-9\s.,-_]+$/;
  const mobilePattern = /^\+?[0-9]{2}[0-9]{10}$/;
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const validateField = (name, value) => {
    let error = "";
    if (name === "firstName" || name === "lastName") {
      if (!value.trim()) {
        error = `${name.replace(/([A-Z])/g, " $1")} is required`;
      } else if (!namePattern.test(value)) {
        error = `${name.replace(/([A-Z])/g, " $1")} must contain only letters`;
      }
    } else if (name === "company") {
      if (!value.trim()) {
        error = "Company name is required";
      } else if (!companyPattern.test(value)) {
        error = "Company name can only contain letters, numbers, spaces, '.', ',', '-', and '_'";
      }
    } else if (name === "mobile") {
      const cleanedValue = value.trim();

      if (!cleanedValue) {
        error = "Mobile number is required";
      } else if (cleanedValue.startsWith("0")) {
        error = "Enter a valid mobile number (e.g., +919876XXXXX0)";
      } else if (!mobilePattern.test(cleanedValue)) {
        error = "Enter a valid mobile number (e.g., +919876XXXXX0)";
      }
    } else if (name === "email") {
      if (!value.trim()) {
        error = "Email is required";
      } else if (!emailPattern.test(value)) {
        error = "Enter a valid email address";
      }
    } else if (name === "dateTime") {
      if (!value) {
        error = "Appointment Date & Time is required";
      } else {
        const selectedDate = moment(value, "DD-MM-YYYY HH:mm");
        const currentDate = moment();

        if (selectedDate.isBefore(currentDate)) {
          error = "Appointment Date must not be in the past";
        }
      }
    }
    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };


  const handleRequestDemo = async () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      newErrors[key] = validateField(key, formData[key]);
    });
    newErrors.dateTime = validateField("dateTime", dateTime);

    setErrors(newErrors);

    // if (Object.values(newErrors).every((error) => error === "")) {
    //   setPopupVisible(true);
    // }
    const formattedDateTime = moment(dateTime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    const requestBody = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobileNo: formData.mobile,
      emailId: formData.email,
      companyName: formData.company,
      appointmentDtTime: formattedDateTime,
    };

    try {
      const response = await ClientPreLoginService.requestDemo(requestBody);
      if (response.status === 200) {
        setPopupVisible(true);
        setFormData({
          firstName: "",
          lastName: "",
          mobile: "",
          email: "",
          company: "",
        });
        setDateTime("");
        setErrors({});
        if (datePickerRef.current && datePickerRef.current._flatpickr) {
          datePickerRef.current._flatpickr.clear();
        }
      }
    } catch (error) {
      console.error("Demo request failed:", error);
    }
  };

  const openDatePicker = () => {
    if (datePickerRef.current?._flatpickr) {
      datePickerRef.current._flatpickr.open();
    }
  };

  const openTimePicker = () => {
    if (datePickerRef.current?._flatpickr) {
      datePickerRef.current._flatpickr.set("enableTime", true);
      datePickerRef.current._flatpickr.set("noCalendar", true);
      datePickerRef.current._flatpickr.open();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fluid-container">
        <div className="contact-sales-row row">
          <div className="col-lg-6 form-button-contactsales-container">
            <div className='contact-sales-breadcrumb'>
              <span style={{
                color: '#F35824', fontWeight: '600', textDecoration: 'none', marginRight: '50px'
              }}>
                <span
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                >
                  Back
                </span>
                <span style={{ marginLeft: '10px' }}> /</span>
                <span style={{ marginLeft: '10px' }}> Contact Sales</span>
              </span>
            </div>
            <h2 className="section-heading">Book Your Demo Now</h2>
            <div className="form-fields">
              <div className="contact-sales-form-row">
                <div className="col-md-6 ">
                  <div className="input-group">
                    <label htmlFor="first-name">First Name*</label>
                    <input
                      id="first-name"
                      name="firstName"
                      type="text"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className={errors.firstName ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.firstName && <span className="error-text">{errors.firstName}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="last-name">Last Name*</label>
                    <input
                      id="last-name"
                      name="lastName"
                      type="text"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className={errors.lastName ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.lastName && <span className="error-text">{errors.lastName}</span>}
                  </div>
                </div>
              </div>
              <div className="contact-sales-form-row">
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="mobile">Mobile*</label>
                    <input
                      id="mobile"
                      name="mobile"
                      type="tel"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      className={errors.mobile ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.mobile && <span className="error-text">{errors.mobile}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="email">Email Id*</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={errors.email ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.email && <span className="error-text">{errors.email}</span>}
                  </div>
                </div>
              </div>
              <div className="contact-sales-form-row">
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="company">Company*</label>
                    <input
                      id="company"
                      name="company"
                      type="text"
                      value={formData.company}
                      onChange={handleInputChange}
                      className={errors.company ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.company && <span className="error-text">{errors.company}</span>}
                  </div>
                </div>
              </div>
              <div className="contact-sales-form-row">
                <div className="col-md-11">
                  <div className="input-group">
                    <label htmlFor="appointment">Appointment Date & Time*</label>
                    <div style={{ position: 'relative', width: '100%' }}>
                      <input
                        id="appointment-date-time"
                        ref={datePickerRef}
                        type="text"
                        className={`form-control ${errors.dateTime ? "input-error" : ""}`}
                        style={{ paddingRight: '80px', marginBottom: '10px', background: 'rgba(255, 255, 255, 1)', width: '100%', boxShadow: 'none' }}
                        defaultValue=""
                        readOnly
                        value={dateTime}
                      />

                      <FaCalendar
                        onClick={openDatePicker}
                        style={{
                          position: "absolute",
                          right: "35px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#2D3E50",
                        }}
                      />
                      <FaClock
                        onClick={openTimePicker}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#2D3E50",
                        }}

                      />
                    </div>
                    {errors.dateTime && <span className="error-text">{errors.dateTime}</span>}
                  </div>
                </div>
              </div>

              <button className="request-demo-btn" onClick={handleRequestDemo}>
                Contact Sales
              </button>
            </div>
          </div>
          <div
            className="col-lg-6 demo"
            style={{ background: 'linear-gradient(183.88deg, #2F2F2F -24.77%, #000000 71.42%)' }}
          >
            <div className='demo-contents'>
              <h2 className="section1-heading">Discover Why Leaderly is the Right Fit for Your Organization</h2>
              <p className="descriptions">
                What to Expect:
              </p>
              <ul className="demo-points">
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  A quick discussion to understand your hiring needs and how Leaderly can help you build a strong talent pipeline.                </li>
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  A live demo for an immersive experience and full access to platform features.              </li>
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  Instant, detailed answers to all your questions.              </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {popupVisible && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-button" onClick={() => setPopupVisible(false)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
            <img src={Success} alt="success logo" className="success-logo" />
            <h3>Demo has been Successfully Booked</h3>
            <p>A customer care representative will get back to you</p>
          </div>
        </div>
      )}
      <style>
        {`
          .error-text {
            color: red;
            font-size: 12px;
            margin-top: 5px;
            display: block;
          }
          .input-error {
            border-color: red;
          }
        `}
      </style>
    </>
  );
};

export default ContactSales;